/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NfcsPainScaleAliases {
  CHIN_QUIVERING_FIELD = 'chin-quivering-field',
  CHIN_QUIVERING_FORM = 'chin-quivering-form',
  CHIN_QUIVERING_RADIO_GROUP = 'chin-quivering-radio-group',
  CHIN_QUIVERING_TEXT = 'chin-quivering-text',
  DEEPEN_NASOLABIAL_FOLD_FIELD = 'deepen-nasolabial-fold-field',
  DEEPEN_NASOLABIAL_FOLD_FORM = 'deepen-nasolabial-fold-form',
  DEEPEN_NASOLABIAL_FOLD_RADIO_GROUP = 'deepen-nasolabial-fold-radio-group',
  DEEPEN_NASOLABIAL_FOLD_TEXT = 'deepen-nasolabial-fold-text',
  HALF_OPEN_LIPS_FIELD = 'half-open-lips-field',
  HALF_OPEN_LIPS_FORM = 'half-open-lips-form',
  HALF_OPEN_LIPS_RADIO_GROUP = 'half-open-lips-radio-group',
  HALF_OPEN_LIPS_TEXT = 'half-open-lips-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  NFCS_CONTEXTUAL_BAR = 'nfcs-contextualBar',
  NFCS_PAIN_SCALE_LAYOUT = 'nfcs-pain-scale-layout',
  NFCS_PANEL = 'nfcs-panel',
  PROMINENT_FOREHEAD_FIELD = 'prominent-forehead-field',
  PROMINENT_FOREHEAD_FORM = 'prominent-forehead-form',
  PROMINENT_FOREHEAD_RADIO_GROUP = 'prominent-forehead-radio-group',
  PROMINENT_FOREHEAD_TEXT = 'prominent-forehead-text',
  PUCKERED_LIPS_FIELD = 'puckered-lips-field',
  PUCKERED_LIPS_FORM = 'puckered-lips-form',
  PUCKERED_LIPS_RADIO_GROUP = 'puckered-lips-radio-group',
  PUCKERED_LIPS_TEXT = 'puckered-lips-text',
  REFERENCE_LINK = 'reference-link',
  REFERENCE_MODAL = 'reference-modal',
  REFERENCE_PANEL = 'reference-panel',
  SQUINTED_EYES_FIELD = 'squinted-eyes-field',
  SQUINTED_EYES_FORM = 'squinted-eyes-form',
  SQUINTED_EYES_RADIO_GROUP = 'squinted-eyes-radio-group',
  SQUINTED_EYES_TEXT = 'squinted-eyes-text',
  STRETCHED_MOUTH_FIELD = 'stretched-mouth-field',
  STRETCHED_MOUTH_FORM = 'stretched-mouth-form',
  STRETCHED_MOUTH_RADIO_GROUP = 'stretched-mouth-radio-group',
  STRETCHED_MOUTH_TEXT = 'stretched-mouth-text',
  TENSE_TONGUE_FIELD = 'tense-tongue-field',
  TENSE_TONGUE_FORM = 'tense-tongue-form',
  TENSE_TONGUE_RADIO_GROUP = 'tense-tongue-radio-group',
  TENSE_TONGUE_TEXT = 'tense-tongue-text',
  TEXT_PAIN_SCALE_FIELD_REFERENCE = 'text-pain-scale-field-reference',
}
export { NfcsPainScaleAliases };
